module.exports = __webpack_public_path__ + "static/img/kolasdkjjasljasd222.350ba7ef.jpg";